import * as THREE from 'three';

import React, { useMemo, useRef } from 'react';

export const Ground: React.FC = () => {
  // Create a reference to the mesh
  const meshRef = useRef<THREE.Mesh>(null);

  // Create material with memoization to avoid recreation
  const material = useMemo(() => {
    return new THREE.MeshLambertMaterial({
      color: '#8BC34A',
      flatShading: true,
    });
  }, []);

  // Create geometry with memoization
  const geometry = useMemo(() => {
    return new THREE.PlaneGeometry(500, 500, 20, 20);
  }, []);

  return (
    <mesh
      ref={meshRef}
      rotation={[-Math.PI / 2, 0, 0]}
      position={[0, -0.01, 0]}
      receiveShadow
      geometry={geometry}
      material={material}
    />
  );
};

// These colors can be used for terrain variations in the future
/*const colors = [
  '#7CB342', // Base green
  '#8BC34A', // Lighter green
  '#689F38', // Darker green
  '#558B2F', // Forest green
  '#33691E', // Deep green
  '#795548', // Brown for mountains
  '#A1887F', // Light brown for hills
  '#FDD835', // Sandy yellow
  '#F57F17', // Dark sand
  '#BDBDBD', // Gray for rocks
];*/
